import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FocusToService {
  constructor(@Inject(DOCUMENT) private readonly document: any) {}

  focusTo(id: string): void {
    const elementToFocus = this.document.getElementById(id);

    if (elementToFocus) {
      elementToFocus.focus();
    }
  }
}
